import { useApi } from '@/api';
import { ChartTimeFilter, ChartSkeleton } from '@/components';
import {
  Flex,
  formatNumber,
  BarChart,
  CurrencyValue
} from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import { useChartPeriod } from '@/hooks';

export default function PSM3VolumeChart() {
  const theme = useTheme();
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  const [data, error] = useApi({
    url: '/arbitrum/bridge/historic-volume/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  const datasets = useMemo(() => {
    return [
      {
        xField: 'date',
        yField: 'deposit_volume',
        label: 'To Arbitrum',
        backgroundColor: theme.colors.chartUp
      },
      {
        xField: 'date',
        yField: 'withdraw_volume',
        label: 'From Arbitrum',
        backgroundColor: theme.colors.chartDown
      }
    ];
  }, [theme.colors]);
  const yScaleValueFormatter = (value) => {
    return formatNumber(Number(value));
  };
  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      return (
        <CurrencyValue
          value={Number(value)}
          options={{
            currency: 'USD'
          }}
        />
      );
    }

    return formatValue;
  }, []);
  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <BarChart
          key={'Volume'}
          data={data}
          datasets={datasets}
          valueFormatter={valueFormatter}
          yScaleValueFormatter={yScaleValueFormatter}
          timeFilter={timeFilter}
          config={config}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
